import React from "react";
import {MyNotificationViewCard} from "./MyNotificationViewCard";

export function MyNotificationViewPage() {

    return (
                <MyNotificationViewCard/>
    );
}
